import type { ReactNode } from 'react';

import { TagDangerRounded } from '@components/core-ui/Tag/variations/TagDangerRounded';
import { TagInfoRounded } from '@components/core-ui/Tag/variations/TagInfoRounded';
import { TagMutedRounded } from '@components/core-ui/Tag/variations/TagMutedRounded';
import { TagSuccessRounded } from '@components/core-ui/Tag/variations/TagSuccessRounded';
import type { TTagProps } from '@components/core-ui/Tag/types/TProps';

const SCORE_LABELS: Record<string, string> = {
  good: 'Good',
  partial: 'Partial',
  bad: 'Bad',
};

export function SpeakerLabellingScoreTag({ score }: { score?: string | null }): ReactNode {
  if (!score || score === 'unknown') {
    return <TagMutedRounded>Unknown</TagMutedRounded>;
  }
  const label = SCORE_LABELS[score] ?? score;
  const props: TTagProps = { children: label };
  if (score === 'good') {
    return <TagSuccessRounded {...props} />;
  }
  if (score === 'partial') {
    return <TagInfoRounded {...props} />;
  }
  if (score === 'bad') {
    return <TagDangerRounded {...props} />;
  }
  return <TagMutedRounded {...props} />;
}
